const icon = (name) => `${process.env.PUBLIC_URL || ""}/assets/icons/${name}`;

export const navigation = [
  {
    text: "Pulse",
    path: "/pulse",
    icon: icon("pulse.png"),
    bgColor: "salonNav",
  },
  {
    text: "Lens",
    path: "/lens",
    icon: icon("lens.png"),
    bgColor: "stylistNav",
  },
  { text: "Device Status", path: "/home", icon: "home" },
  {
    text: "Scheduler",
    path: "/scheduler",
    icon: icon("calendar.png"),
  },
  {
    text: "Till",
    path: "/till",
    icon: "pointOfSale",
  },
  {
    text: "Teams",
    path: "/manage-users",
    icon: "group",
  },

  {
    text: "Admin Panel",
    icon: icon("admin.png"),
    items: [
      {
        text: "Add a Salon",
        path: "/create-salon",
        //visible: false,
      },
      {
        text: "Salon Settings",
        path: "/configure-salon",
        //visible: false,
      },
      {
        text: "Manage Categories",
        path: "/manage-categories",
      },
      {
        text: "Create Service",
        path: "/create-service",
        visible: false,
      },
      {
        text: "Manage Services",
        path: "/search-services",
      },
      {
        text: "Add a stylist",
        path: "/create-account?role=stylist",
        visible: false,
      },
      {
        text: "Manage Stylists",
        path: "/search-stylists",
      },
      {
        text: "Add Client",
        path: "/create-client",
        visible: false,
      },
      {
        text: "Manage Clients",
        path: "/edit-client",
      },
      {
        text: "Manage Distributors",
        path: "/manage-distributors",
      },
      {
        text: "Manage Cancellation Reasons",
        path: "/manage-cancellation-reasons",
      },
    ],
  },{
    text: "Report Center",
    icon: icon("report.png"),
    items: [
      {
        text: "Appt. Booking Sources",
        path: "/booking-sources-report",
      },
      {
        text: "Checkout Summary",
        path: "/checkout-summary",
      },
      {
        text: "Clients Retention Report",
        path: "/clients-retention-report",
      },
      {
        text: "Formula Tracker",
        path: "/formula-tracker",
      },
      {
        text: "Inventory Receiving",
        path: "/inventory-receiving-report",
      },
      {
        text: "QUE Inventory Received",
        path: "/mica-inventory-receiving-report",
      },
      {
        text: "Re-Order report",
        path: "/re-order-report",
      },
      {
        text: "Re-Weight report",
        path: "/re-weight-report",
      },
      {
        text: "Rolled Transactions",
        path: "/rolled-reports-sql",
      },
      {
        text: "Sales Report",
        path: "/sales-report",
      },
      {
        text: "Salon Container Usage",
        path: "/salon-reports-sql",
      },
      {
        text: "Stylist Spending",
        path: "/stylist-spend-sql",
      },
      {
        text: "Transactions",
        path: "/reports-sql",
      },
    ],
  },
  {
    text: "Inventory",
    icon: icon("inventory.png"),
    items: [
      {
        text: "Current Inventory - Full List",
        path: "/inventory",
      },
      {
        text: "Reorder Inventory",
        path: "/reorder",
      },
      {
        text: "Inventory Receiving",
        path: "/inventory-receiving",
      },
      {
        text: "Manage Products",
        path: "/manage-products",
      },
      {
        text: "Product Usage",
        path: "/reporting",
      },
      {
        text: "Product Catalogue",
        path: "/manufacturers-sql",
      },
    ],
  },
  {
    text: "Community",
    icon: "group",
    items: [
      {
        text: "Interact with Community",
      },
      {
        text: "Unlimited Members",
      },
      {
        text: "Special Announcements",
      },
      {
        text: "Documents",
      },
      {
        text: "Photos",
      },
      {
        text: "Formulas",
      },
      {
        text: "Online Payments",
      },
    ],
    visible: false,
  },

  {
    text: "Pivotgrid Class",
    path: "/pivotgrid-class",
    icon: "folder",
    visible: false,
  },
];
